import { axiosSubstanceInstance } from "../AxiosConfiguration";
import { axiosRelationshipInstance } from "../AxiosConfiguration";

export const getFaithPackages = async (faith) => {
  try {
    const response = await axiosSubstanceInstance.get(
      `/api/faith/get-faiths`,
      {
        params: faith ? { faith } : {},
      }
    );
    return response.data; // Handle the r  qesponse as needed
  } catch (error) {
    console.error("Error fetching faith packages:", error);
    throw error; // Re-throw the error to handle it in the component
  }
};

export const getProducts = async () => {
  try {
    const v2 = await axiosSubstanceInstance.get(
      `/api/plans/products`
    );
    return v2.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getChangePlan = async () => {
  try {
    const response = await axiosSubstanceInstance.get(`/api/subscription/update/billing-cycle`);
    return response.data;
  } catch (error) {
    console.error("Error fetching billing cycle options:", error);
    throw error;
  }
};

export const UpdateChangePlan = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/update/billing-cycle`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating billing cycle:", error);
    throw error;
  }
};

export const getPricing = async (product_id) => {
  try {
    const response = await axiosSubstanceInstance.get(
      `/api/subscription/get-prices`,
      {
        params: { product_id: product_id },
      }
    );
    return response.data; // Handle the response as needed
  } catch (error) {
    console.error("Error fetching faith packages:", error);
    throw error; // Re-throw the error to handle it in the component
  }
};

export const renewSubscription = async (data) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscription/renew`,
      data
    );
    return response.data; // Handle the response as needed
  } catch (error) {
    console.error("Error renewal:", error);
    throw error; // Re-throw the error to handle it in the component
  }
};

export const startSubscription = async (data) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/checkout`,
      data
    );
    return response.data; // Handle the response as needed
  } catch (error) {
    console.error("Error creating subscription:", error);
    throw error; // Re-throw the error to handle it in the component
  }
};

export const getUserSubscriptionDetails = async () => {
  try {
    // Prefer new unified subscriptions endpoint
    try {
      const v2 = await axiosSubstanceInstance.get(`/api/subscriptions/`, {
        params: { page: 1, limit: 10 },
      });
      return v2.data;
    } catch (innerErr) {
      console.error("Error fetching subscription details:", innerErr);
    }
  } catch (error) {
    console.error("Error fetching subscription details:", error);
    throw error;
  }
};

export const getLicenceList = async () => {
  try {
    // New endpoint returns: { status, status_code, message, payload: { subscription_id, unassigned_count, unassigned: [...] } }
    const response = await axiosSubstanceInstance.get(
      `/api/subscriptions/licenses/unassigned`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching unassigned licenses:", error);
    throw error;
  }
};
// Assign a license to a user under a given subscription
export const assignLicense = async (user_details) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/assign`,
      user_details
    );
    return response.data;
  } catch (error) {
    console.error("Error assigning license:", error);
    throw error;
  }
};
///api/subscription/verify/coupon
export const checkValidCoupon = async (promo_code) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/verify/coupon`,
      { promo_code: promo_code }
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying coupon:", error);
    throw error;
  }
};
export const getcarryminutes = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/minutes/transfer`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error transferring minutes:", error);
    throw error;
  }
};

export const postreqminutes = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/minutes/requests`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error creating minute request:", error);
    throw error;
  }
};

export const addlicensedusers = async (payload) => {
  try {
    const response = await axiosRelationshipInstance.post(
      `/api/user/subscriptions/create/licensed/users`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error transferring minutes:", error);
    throw error;
  }
};

export const transferuser = async (licenseId) => {
  try {
    const response = await axiosSubstanceInstance.delete(
      `/api/subscriptions/assignments/${licenseId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error removing license assignment:", error);
    throw error;
  }
};

export const createAddon = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/checkout`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error transferring minutes:", error);
    throw error;
  }
};

export const billingPortal = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/billing/portal`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error creating billing portal session:", error);
    throw error;
  }
};

export const updateUserFaith = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      "/api/faith/me",
      payload
    );
    // Invalidate cached belief system so next read fetches fresh data
    try {
      localStorage.removeItem("beliefSystem");
      localStorage.removeItem("dynamic_dashboard_prompts");
    } catch (_) { }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserFaith = async () => {
  try {
    // Prefer cached belief system from localStorage if available
    const cached = localStorage.getItem("beliefSystem");
    if (cached && cached !== "undefined") {
      const payload = JSON.parse(cached);
      return { status: "success", payload };
    }

    // Fallback to API when cache is missing
    const response = await axiosSubstanceInstance.get("/api/faith/me");
    try {
      if (response?.data?.payload) {
        localStorage.setItem("beliefSystem", JSON.stringify(response.data.payload));
      }
    } catch (_) { }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelMembership = async () => {
  try {
    const response = await axiosSubstanceInstance.delete(
      `/api/subscriptions/cancel`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reactivateSubscription = async () => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/reactivate`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const verifySubscription = async (payload) => {
  try {
    // Try new verification endpoint first; fallback to legacy
    const v2 = await axiosSubstanceInstance.post(
      `/api/subscriptions/verify/checkout`,
      payload
    );
    return v2.data;
  } catch (error) {
    throw error;
  }
};

export const createDirectSubscription = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/create`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error creating direct subscription:", error);
    throw error;
  }
};

export const changePlan = async (payload) => {
  try {
    const response = await axiosSubstanceInstance.post(
      `/api/subscriptions/change-plan`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error changing plan:", error);
    throw error;
  }
};
